module.exports = __webpack_public_path__ + "static/media/Presentacion.c7e42f74.svg";